import { RestaurantResponseType } from '../restaurant/restaurant.types';

export enum TableStatusType {
  PreparingOrder = 'preparingOrder',
  OrderPerpared = 'orderPerpared',
  None = 'none',
  OnHold = 'on-hold',
}

export enum DelayedStatusType {
  OrderDelayed = 'orderDelayed',
  OrderDelayedAgain = 'orderDelayedAgain',
  None = 'none',
}

export enum TableOrderSourceType {
  Nugget = 'nugget',
  QR = 'qr',
}

export interface TableRequestType {
  tableNo: string;
  sizeDetail: {
    iconName: string;
    gridSize: string;
    tableNo: string;
    rotationAngle: number;
    size: number;
    height: number;
    width: number;
  };
}

export interface UpdateTableRequestType {
  tableLocation?: string;
  totalSeatsNo?: number;
  noOfGuests?: number;
}

export interface ChangeTableRequestType {
  tableId: number;
  orderId: number;
}

export interface FreeTableRequestType {
  tableId: number;
  source?: TableOrderSourceType;
  deviceSerial?: string;
}

export interface TableCreateType {
  restaurant: RestaurantResponseType;
  tableNo: string;
  tableLocation: string;
  totalSeatsNo: number;
  noOfGuests: number;
  id: number;
  orderPunched: boolean;
  foodOnTable: boolean;
  available: boolean;
  tableStatus: TableStatusType;
  delayedStatus?: DelayedStatusType;
  createdAt: Date;
  updatedAt: Date;
}
